export class DirtyOutNeedEncItem {
  public sync_id: number;
  public servtime: number;
  public share_id: number;
  public is_enced: number;
  public metaname: string;
  public blob_id: number;
  public new_key_id: string;
  public data_keys: DirtyOutNeedEncDataKeys[];
}

export class DirtyOutNeedEncDataKeys {
  public sync_id?: number;
  public blob_id: number;
  public sharekey_id: string;
  public enc_data_key: string;
}
